import * as React from 'react';

import {Field, FieldArray, reduxForm} from 'redux-form';

import {ConditionalCheckboxInput} from 'shells/form/conditional-checkbox-input';
import {FormField} from 'shells/form/form-field';
import {SidebarFormWrapper} from 'shells/form/sidebar-form-wrapper';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import type {ThreadType} from 'nutshell-graphql-types';

import {TagSelect, PipelineSelectSingle} from '../../core/form/fields';

const FORM_NAME = 'RULES_SIDEBAR_FORM';

type Props = {
    onClose: () => void;
    onSubmit: (values: any) => void;
    addTags: boolean;
    setAddTags: (checked: boolean) => void;
    initialValues?: any;
    // These props come from redux-form
    handleSubmit: (eventOrSubmit?: any) => undefined | Promise<any>;
    invalid: boolean;
    pristine: boolean;
    submitting: boolean;
    messageType: ThreadType;
};

function RulesSidebarConnected(props: Props) {
    const {handleSubmit, invalid, pristine, submitting, ...rest} = props;

    return (
        <SidebarFormWrapper
            title='Create a lead'
            // @ts-expect-error
            onClose={props.onClose}
            isNewItem={true}
            handleSubmit={handleSubmit}
            invalid={invalid}
            pristine={pristine}
            submitting={submitting}
            isSaving={submitting}
            saveFailedErrorMessage={null}
            {...rest}
        >
            <div className='flex flex-dir-col pad-16'>
                <Body>
                    Add a rule that automatically creates a lead in Nutshell when a message is
                    received.
                </Body>
                <Divider spacing={16} variant='line--horizontal' />
                <StackLegacy spacing={8}>
                    <Body>Select a pipeline</Body>
                    <Field
                        name='stagesetId'
                        component={PipelineSelectSingle}
                        includeAutoDistribute={true}
                    />
                </StackLegacy>
                <FormField innerId='tagIds'>
                    <ConditionalCheckboxInput
                        label='Add a tag'
                        isLarge={true}
                        checked={props.addTags}
                        onChange={(checked) => props.setAddTags(checked)}
                    >
                        <FieldArray
                            name='tagIds'
                            component={TagSelect}
                            shouldAnd={true}
                            tagType='LEAD'
                        />
                    </ConditionalCheckboxInput>
                </FormField>
            </div>
        </SidebarFormWrapper>
    );
}

export const RulesSidebarForm = reduxForm({
    form: FORM_NAME,
    destroyOnUnmount: true,
    // @ts-expect-error
})(RulesSidebarConnected);
